<!-- Header Section — kept outside the loading branch so filtering doesn't drop focus -->
<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div>
    <h5 class="mb-1 fw-bold">Inventory</h5>
    <span class="sub-text">Monitor raw material stock levels</span>
  </div>

  <button
    class="btn btn-soft-primary btn-sm d-flex align-items-center gap-2"
    (click)="exportInventory()"
    [disabled]="isExporting">
    <i class="bi bi-download"></i>
    Export Report
  </button>
</div>

<div class="row g-2 mb-4">
  <div class="col-12 col-md-6 col-lg-3 ps-0">
    <div class="input-group">
      <span class="input-group-text bg-white border-end-0">
        <i class="bi bi-search text-muted"></i>
      </span>
      <input
        type="text"
        class="form-control border-start-0"
        placeholder="Search by name..."
        [(ngModel)]="searchTerm"
        (keyup)="onSearchKeyUp()" />
    </div>
  </div>

  <div class="col-12 col-md-6 col-lg-3 ps-0">
    <ng-select
      placeholder="All Raw Materials"
      [items]="rawMaterials"
      [(ngModel)]="selectedRawMaterial"
      bindValue="id"
      bindLabel="name"
      [clearable]="true"
      [searchable]="true"
      (ngModelChange)="onFilterChange()" />
  </div>

  <div class="col-12 col-md-4 col-lg-2 ps-0">
    <ng-select
      placeholder="All Categories"
      [items]="rawMaterialCategories"
      [(ngModel)]="selectedRawMaterialCategory"
      bindValue="id"
      bindLabel="name"
      [clearable]="true"
      [searchable]="false"
      (ngModelChange)="onRawMaterialCategorySelected($event)" />
  </div>

  <div class="col-12 col-md-4 col-lg-2 ps-0">
    <ng-select
      placeholder="All Warehouses"
      [items]="wareHouses"
      [(ngModel)]="selectedWarehouse"
      bindValue="id"
      bindLabel="name"
      [clearable]="true"
      [searchable]="true"
      (ngModelChange)="onWareHouseSelected(selectedWarehouse!)" />
  </div>

  <div class="col-12 col-md-4 col-lg-2 ps-0">
    <ng-select
      placeholder="All Companies"
      [items]="companies"
      [(ngModel)]="selectedCompany"
      bindValue="id"
      bindLabel="name"
      [clearable]="true"
      [searchable]="true"
      (ngModelChange)="onCompanySelected()" />
  </div>
</div>

@if (isInventoryDataLoading) {
  <app-loading-spinner></app-loading-spinner>
} @else {
  <div class="table-responsive">
    @if (rawMaterialStock.length > 0) {
      <app-table [columns]="inventoryColumns" [data]="rawMaterialStock" (onClickAdjust)="openAdjustmentModal($event)" />
    } @else {
      <div class="empty-state-container">
        <i class="bi bi-box-seam"></i>
        @if (hasActiveFilters) {
          <h5>No Matching Stock</h5>
          <p>No raw material in stock matches the current filters.</p>
          <button class="btn btn-outline-primary" (click)="clearFilters()">Clear filters</button>
        } @else {
          <h5>No Stock Available</h5>
          <p>No raw materials are currently in stock.</p>
          <p class="small text-muted mb-0">
            Stock arrives through a
            <strong>Purchase Order</strong>
            .
          </p>
        }
      </div>
    }
  </div>

  @if (!isInventoryDataLoading && rawMaterialStock.length > 0) {
    <div class="mt-4">
      <app-pagination
        [currentPage]="currentPage"
        [totalCount]="totalCount"
        [pageSize]="10"
        [hasNextPage]="hasNextPage"
        [hasPreviousPage]="hasPreviousPage"
        (pageChange)="onPageChange($event)"></app-pagination>
    </div>
  }
}

<!-- Adjust stock modal -->
<ng-template #adjustmentModal>
  <div class="modal-header">
    <h5 class="modal-title fw-bold">Adjust Stock</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeAdjustmentModal()"></button>
  </div>

  @if (adjustmentContext) {
    <app-stock-adjustment-form
      [context]="adjustmentContext"
      (saved)="onAdjustmentSaved()"
      (cancelled)="closeAdjustmentModal()"></app-stock-adjustment-form>
  }
</ng-template>
